import { ReactNode } from 'react'
import cx from 'classnames'
import { find } from 'lodash'

import DropdownStyles from 'common/Dropdown/Dropdown.module.scss'
import { Dropdown } from 'common/Dropdown/Dropdown'

export interface Props {
  className?: string
  dropdownClassName?: string
  name: string
  options: { label: ReactNode; shortLabel?: ReactNode; value: string | number }[]
  setFieldValue: (name: string, value: string | number) => void
  value?: string | number
}

export const DropdownSelect = ({ className, dropdownClassName, name, options, setFieldValue, value }: Props) => {
  const selectedOption = find(options, { value })

  return (
    <Dropdown
      containerClassName={cx(className)}
      dropdownClassName={cx(DropdownStyles.dropdownContainer, dropdownClassName)}
      trigger={
        <button aria-label={`Select ${name}`} type="button">
          {selectedOption?.shortLabel || selectedOption?.label || '-'}
        </button>
      }
      triggerOn="click"
    >
      <ul className={DropdownStyles.dropdownList}>
        {options.map((option) => (
          <li key={option.value}>
            <button
              className={cx({ [DropdownStyles.active]: selectedOption?.value === option.value })}
              onClick={() => setFieldValue(name, option.value)}
              type="button"
            >
              {option.label}
            </button>
          </li>
        ))}
      </ul>
    </Dropdown>
  )
}
